@if (score) {
  <div
    class="fixed inset-0 z-[1000] flex items-center justify-center p-4 bg-slate-900/40 backdrop-blur-sm"
    role="dialog"
    aria-modal="true"
    aria-label="Din personlige plan"
    (click)="onClose()"
  >
    <div
      class="w-full max-w-[520px] max-h-[90vh] overflow-y-auto rounded-2xl border !border-slate-200/70 bg-white p-6 shadow-[0_24px_60px_-24px_rgba(15,23,42,.45)]"
      (click)="$event.stopPropagation()"
    >
      <div
        class="inline-flex items-center gap-1.5 text-[12px] font-semibold uppercase tracking-[0.12em] text-[var(--primary-color)]"
      >
        <span class="w-1.5 h-1.5 rounded-full bg-[var(--primary-color)]"></span>
        Din personlige plan
      </div>

      <div class="flex items-start gap-3 mt-3">
        <span
          class="shrink-0 w-10 h-10 rounded-xl flex items-center justify-center bg-[color-mix(in_srgb,var(--primary-color)_10%,white)] text-[var(--primary-color)]"
        >
          <igntr-icon name="check" [size]="20"></igntr-icon>
        </span>
        <div>
          <div class="text-[12px] font-medium text-slate-500">Dit spor</div>
          <h3 class="text-[20px] leading-tight font-semibold text-slate-900">
            {{ score.trackLabel }}
          </h3>
        </div>
      </div>

      @if (loading) {
        <div
          class="flex flex-col items-center justify-center gap-3 py-10 text-slate-500"
        >
          <span
            class="w-8 h-8 rounded-full border-2 border-slate-200 border-t-[var(--primary-color)] animate-spin"
          ></span>
          <span class="text-[13px]">Genererer din plan…</span>
        </div>
      } @else if (plan) {
        @if (plan.summary) {
          <p class="text-[14px] leading-relaxed text-slate-600 mt-3">
            {{ plan.summary }}
          </p>
        }

        @if (plan.focusAreas.length) {
          <div class="mt-5">
            <div class="text-[13px] font-semibold text-slate-900">
              Dine fokusområder
            </div>
            <div class="mt-2 flex flex-col gap-2">
              @for (area of plan.focusAreas; track area.name) {
                <div
                  class="w-full px-3.5 py-3 rounded-xl border !border-[var(--primary-color)] bg-[color-mix(in_srgb,var(--primary-color)_7%,white)]"
                >
                  <div class="flex items-center gap-2">
                    <span class="text-[14px] font-medium text-slate-800">
                      {{ area.name }}
                    </span>
                    @if (area.category) {
                      <span
                        class="shrink-0 inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold uppercase tracking-[0.08em] bg-[color-mix(in_srgb,var(--primary-color)_14%,white)] text-[var(--primary-color)]"
                      >
                        {{ area.category }}
                      </span>
                    }
                  </div>
                  @if (area.description) {
                    <p class="text-[13px] leading-relaxed text-slate-600 mt-1.5">
                      {{ area.description }}
                    </p>
                  }
                </div>
              }
            </div>
          </div>
        }
      } @else if (score.focusAreas.length) {
        <div class="mt-5">
          <div class="text-[13px] font-semibold text-slate-900">
            Dine fokusområder
          </div>
          <div class="mt-2 flex flex-col gap-2">
            @for (area of score.focusAreas; track area) {
              <div
                class="w-full flex items-center gap-3 px-3.5 py-3 rounded-xl border !border-[var(--primary-color)] bg-[color-mix(in_srgb,var(--primary-color)_7%,white)]"
              >
                <span
                  class="shrink-0 w-6 h-6 rounded-md flex items-center justify-center bg-[var(--primary-color)] text-white"
                >
                  <igntr-icon name="check" [size]="14"></igntr-icon>
                </span>
                <span class="text-[14px] text-slate-700">{{ area }}</span>
              </div>
            }
          </div>
        </div>
      }

      <div class="mt-6 flex justify-end">
        <button
          type="button"
          (click)="onClose()"
          class="inline-flex items-center gap-1.5 h-10 px-5 rounded-lg bg-[var(--primary-color)] text-white text-[14px] font-medium shadow-[0_8px_18px_-10px_rgba(15,23,42,.5)] transition hover:opacity-90"
        >
          Fortsæt
          <igntr-icon name="chevronR" [size]="14"></igntr-icon>
        </button>
      </div>
    </div>
  </div>
}
